import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Consultation = () => {
  const location = useLocation();
  const [player, setPlayer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 상담신청`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  useEffect(() => {
    // Google Tag Manager 스크립트 추가
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-LYT78YCDYK";
    script.async = true;
    document.body.appendChild(script);

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-LYT78YCDYK');
        `;
    document.body.appendChild(inlineScript);
  }, []);

  useEffect(() => {
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      const newPlayer = new window.YT.Player("u_player", {
        height: "560",
        width: "315",
        videoId: "oYLIXq4RQ_c",
      });
      setPlayer(newPlayer);
    };
  }, []);

  const handlePlay = () => {
    if (player) {
      player.playVideo();
      setIsPlaying(true); // 비디오가 재생되면 상태 업데이트
    }
  };

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/consultation">상담 신청</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="consultation">
          <div className="visual">
            <div className="wrap">
              <div className="top init">
                <p>특허로 인정받은 아소비 한글</p>
              </div>
              <div className="tit init">5~9세 학부모가 선택한 아소비!</div>
              <div className="txt init">
                아소비와 함께 시작한 첫 공부
                <br />더 이상의 고민은 없습니다!
              </div>
			{/*<div className="act init">
                <a href="/" id="Request-Quick">
                  지금 바로 상담 신청
                </a>
              </div>*/}
              <div className="ico init">
                <img src="../custom-resources/img/img_zubi2.png" alt="" />
              </div>
            </div>
          </div>
          <div className="why">
            <div className="wrap">
              <div className="tit init">
                약 10만 여명의 학부모님이 <br className="mo-view" />
                신뢰하는 공부방 NO.1
              </div>
              <div className="txt init">
                <img src="../custom-resources/img/img_consultation_why.png" alt="" />
                <p>왜 아소비일까요?</p>
              </div>
            </div>
          </div>
          <div className="reason">
            <div className="desc">
              <div className="vod">
                <div
                  className="img"
                  id="play"
                  onClick={handlePlay}
                  style={isPlaying ? { opacity: 0, zIndex: 1 } : {}}
                >
                  <i></i>
                  <img src="../custom-resources/img/TVC_231011.png" alt="" />
                </div>
                <div className="iframe">
                  <div id="u_player"></div>
                </div>
              </div>
              <div className="cont init">
                <div className="txt">
                  아소비가 TV에 떴다! <br className="mo-view" />
                  <strong>아소비 NEW CF 영상</strong> 공개!
                </div>
                <div className="txt">
                  건강한 공부, 즐거운 공부, 행복한 공부
                  <br />
                  <br />
                  듣기만 해도 신나는 아소비 댄스처럼 공부도 재미있게! <br />
                  스스로 즐겁게 공부하는 힘, 아소비에서 경험해 보세요!
                </div>
              </div>
              <div className="wrap">
                <div className="title init">
                  <p>아소비를 신뢰하는 이유 1.</p>
                </div>
                <div className="cont init">
                  <div className="tit">
                    정확한 진단으로 <br className="mo-view" />
                    맞춤형 학습 제공!
                  </div>
                  <div className="txt">
                    아이의 현재 학습 수준을 정확히 알아야,{" "}
                    <br className="mo-view" />
                    제대로 된 학습 계획을 세울 수 있습니다.
                    <br /> SPTP 종합심리검사와 진단 테스트를 통해 단계별 교재
                    진도를 설정하여 학습을 시작합니다.
                  </div>
                  <div className="act">
                    <a href="/diagnostic" id="diagnostic">
                      진단 테스트
                    </a>
                    <a href="/sptp" id="sptp">
                      SPTP 종합심리검사
                    </a>
                  </div>
                  <div className="img">
                    <img
                      src="../custom-resources/img/img_consultation_reason01.png"
                      alt=""
                    />
                    <img
                      src="../custom-resources/img/img_consultation_reason01_before.png"
                      alt=""
                      className="move_dia"
                    />
                    <img
                      src="../custom-resources/img/img_consultation_reason01_after.png"
                      alt=""
                      className="move_spt"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="title init">
                  <p>아소비를 신뢰하는 이유 2.</p>
                </div>
                <div className="cont">
                  <div className="tit init">아소비만의 체계적인 커리큘럼</div>
                  <div className="txt inti">
                    특화된 교수법을 바탕으로 유치·초등 교육 과정에 연계성을 가진
                    프로그램!
                    <br />
                    아소비만의 커리큘럼으로 학습의 기반을 다져줍니다.
                  </div>
                  <div className="prg">
                    <ul>
                      <li>
                        <div className="prg_t init">
                          <img
                            src="../custom-resources/img/img_consultation_reason02_ico01.png"
                            alt=""
                          />
                          <strong>유치 프로그램</strong>
                          <p>한글, 수학, 칠교, 한자, 논술</p>
                        </div>
                        <div className="prg_c init">
                          <strong>베이직 과정</strong>
                          <p>
                            기초 개념을 다루는
                            <br />
                            가장 첫 단계
                          </p>
                        </div>
                        <div className="prg_c init">
                          <strong>그로우 과정</strong>
                          <p>
                            학습의 기본기를
                            <br />
                            다지는 단계
                          </p>
                        </div>
                        <div className="prg_c init">
                          <strong>마스터 과정</strong>
                          <p>
                            사고력과 창의력을
                            <br />
                            키우는 단계
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="prg_t init">
                          <img
                            src="../custom-resources/img/img_consultation_reason02_ico02.png"
                            alt=""
                          />
                          <strong>초등 프로그램</strong>
                          <p>
                            국어, 수학, 독해논리, <br />
                            논술, 한자, 연산
                          </p>
                        </div>
                        <div className="prg_c init">
                          <strong>초등 과정</strong>
                          <p>
                            교과 과정과 연계된 학습으로 <br />
                            문제 해결 능력을 <br />
                            향상시키는 단계
                          </p>
                        </div>
                        <div className="prg_b init">
                          진단 테스트를 통해 <br />
                          아이의 발달수준에 맞는 <br />
                          교육과정이 진행됩니다. <br />
                        </div>
                      </li>
                      <li>
                        <div className="prg_t init">
                          <img
                            src="../custom-resources/img/img_consultation_reason02_ico03.png"
                            alt=""
                          />
                          <strong>특별 프로그램</strong>
                          <p>
                            언어능력향상 프로그램, <br />
                            학습향상 프로그램
                          </p>
                        </div>
                        <div className="prg_b2 init">
                          어휘력, 이해력, 독해력을 높여 언어적 능력을 향상시키며
                          좌뇌와 우뇌의 발달을 기초로 핵심 능력을 키우는
                          프로그램
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="img init">
                    <img
                      src="../custom-resources/img/img_consultation_character01.png"
                      alt=""
                    />
                    <img
                      src="../custom-resources/img/img_consultation_character02.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="title init">
                  <p>아소비를 신뢰하는 이유 3.</p>
                </div>
                <div className="cont">
                  <div className="tit init">
                    자기 주도 학습 습관의 <br className="mo-view" />
                    길잡이
                  </div>
                  <div className="txt init">
                    주 4회 매일 한 시간! <br />
                    아소비 수업은 스스로 <br className="mo-view" />
                    공부하는 힘을 길러줍니다.
                  </div>
                  <div className="lst">
                    <ul>
                      <li className="init">
                        <i>
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico01.png"
                            alt=""
                          />
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico01_before.png"
                            className="hover1"
                            alt=""
                          />
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico01_after.png"
                            className="hover2"
                            alt=""
                          />
                        </i>
                        <div>
                          <strong>
                            아이가 기다리는 <br />
                            <span>주 4회(월~목) 수업</span>
                          </strong>
                          <p>
                            꾸준한 학습으로 <br />
                            자기 주도 학습 습관을 <br />
                            형성해줍니다.
                          </p>
                        </div>
                      </li>
                      <li className="init">
                        <i>
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico02.png"
                            alt=""
                          />
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico02_before.png"
                            className="hover1"
                            alt=""
                          />
                        </i>
                        <div>
                          <strong>
                            아이가 좋아하는 <br />
                            <span>60분의 놀이식 수업</span>
                          </strong>
                          <p>
                            다양한 학습으로 <br />
                            학습에 대한 흥미와 집중력을 <br />
                            높여줍니다.
                          </p>
                        </div>
                      </li>
                      <li className="init">
                        <i>
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico03.png"
                            alt=""
                          />
                          <img
                            src="../custom-resources/img/img_consultation_reason03_ico03_before.gif"
                            className="hover1"
                            alt=""
                          />
                        </i>
                        <div>
                          <strong>
                            아이가 이해하는 <br />
                            <span>발달 수준에 맞춘 수업</span>
                          </strong>
                          <p>
                            교육 전문가와 함께 <br />
                            맞춤형 수업으로 학습 성취감을 <br />
                            쌓아줍니다.
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="banner">
            <div className="wrap">
              <div className="title init">
                아소비를 만난 학부모님들은 자신 있게 말합니다!
              </div>
            </div>
          </div>
          <div className="review">
            <div className="wrap">
              <div className="desc pink init">
                <div className="age">5~7세</div>
                <div className="tit">
                  어느덧{" "}
                  <p>
                    <b>한글을 떼고 일기를 쓰는 아이가 신기</b>
                  </p>
                  하고 뿌듯해요!
                </div>
                <div className="txt">
                  소근육과 두뇌 계발에 좋은 놀이식 수업으로 5세 우리 아이에게도
                  딱 맞을 것 같았어요! 아소비를 다니며 한 단어씩 읽던 아이가
                  책을 펼치며 자연스럽게 통문장을 읽어내리기 시작했습니다.
                </div>
                <div className="user">카페 소＊＊＊＊＊＊＊</div>
              </div>
              <div className="desc pink init">
                <div className="age">5~7세</div>
                <div className="tit">
                  아이가{" "}
                  <p>
                    <b>공부방 가는 날을 가장 좋아해요!</b>
                  </p>
                </div>
                <div className="txt">
                  월요일부터 목요일까지 꾸준히 학습하고 다양한 교구를 사용하는
                  것이 큰 장점이라고 생각해요! 칠교와 기초 논술 수업을 통해
                  아이의 생각을 커지게 하고 자유로운 생각도 들여다볼 수 있어요.
                </div>
                <div className="user">카페 귀＊＊＊＊＊＊</div>
              </div>
              <div className="desc pink init">
                <div className="age">8~9세</div>
                <div className="tit">
                  엄마 없이도{" "}
                  <p>
                    <b>스스로 노력하여 공부하는 습관</b>
                  </p>
                  을 길렀어요!
                </div>
                <div className="txt">
                  엄마 없이도 스스로 노력하여 공부하는 습관을 길렀어요! 창의성이
                  무너지지 않는 교육을 받고 싶었습니다. 아소비는 학교 공부도
                  확인해 주고 자유로운 표현을 존중해 주는 학습을 할 수 있어
                  아이의 공부 자신감이 솟아나게 해 줍니다.
                </div>
                <div className="user">블로그 g＊＊＊＊＊＊</div>
              </div>
              <div className="desc pink init">
                <div className="age">8~9세</div>
                <div className="tit">
                  또래보다 느린 아이였지만{" "}
                  <p>
                    <b>아소비로 부쩍 성장함을 느낍니다!</b>
                  </p>
                </div>
                <div className="txt">
                  코로나로 학습 부진이 우려되어 보내기 시작한 아소비! 이제는
                  누구보다 자기표현을 잘하고 초등학교 생활도 씩씩하게 잘 해내는
                  걸 보니 배움의 재미를 느끼게 해 준 곳이라는 생각이 먼저
                  듭니다.
                </div>
                <div className="user">인스타 w＊＊＊＊＊＊</div>
              </div>
            </div>
          </div>
          <div className="process">
            <div className="wrap">
              <div className="tit init">아소비 상담 프로세스</div>
              <div className="txt init">
                상담 신청 시, 가까운 아소비 교육원에서 전화 상담을 통해 상담이
                진행됩니다. <br />
                이후 아소비만의 진단을 통해 아이의 수준에 맞는 교재로 학습을
                시작합니다.
              </div>
              <div className="lst init">
                <ul>
                  <li className="init">
                    <p>전화 상담</p>
                  </li>
                  <li className="init">
                    <p>대면 상담</p>
                  </li>
                  <li className="init">
                    <p>아소비 입회</p>
                  </li>
                  <li className="init">
                    <p>
                      <strong>진단 테스트</strong>
                    </p>
                    <a href="/diagnostic">자세히 보기</a>
                  </li>
                  <li className="init">
                    <p>교재 선정</p>
                  </li>
                  <li className="init">
                    <p>
                      <strong>
                        SPTP <br /> 종합심리검사{" "}
                      </strong>
                    </p>
                    <a href="/sptp">자세히 보기</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="banner banner-type2">
            <div className="wrap init">
              <div className="title">
                아이의 <p>첫 학습</p>을 위한 <p>첫 번째 선택</p> <br />
                아소비 <p>상담</p>으로 시작하세요!
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Consultation;
